import { formatPhoneNumber } from './supportFuncs';

export function sendEmailJS(values) {

  console.log("EmailJS - Trying to send registration email");

  console.log("EmailJS Data Received: ", values);

  var studentType = null;
  if (values.studentTypeVal == 1) { studentType = "Beginner Class" };
  if (values.studentTypeVal == 2) { studentType = "Returning Class" };
  if (values.studentTypeVal == 3) { studentType = "Assistant Instructor" };
  console.log("EmailJS - Student Type: ", studentType);

  var session1 = null;
  var session2 = null;
  var session3 = null;
  var session4 = null;
  if (values.session1Val == 0) { session1 = null };
  if (values.session1Val == 1) { session1 = "Oct 17th | Bull St Library" };
  if (values.session2Val == 0) { session2 = null };
  if (values.session2Val == 1) { session2 = "Oct 24th | Bull St Library" };
  if (values.session3Val == 0) { session3 = null };
  if (values.session3Val == 1) { session3 = "Nov 7th  | SW Chatham Library" };
  if (values.session4Val == 0) { session4 = null };
  if (values.session4Val == 1) { session4 = "Nov 14th | SW Chatham Library" };

  console.log("EmailJS - Session1: ", session1);
  console.log("EmailJS - Session2: ", session2);
  console.log("EmailJS - Session3: ", session3);
  console.log("EmailJS - Session4: ", session4);

  var studentLaptop = null;
  if (values.studentLaptopVal == 0) { studentLaptop = "Yes" };
  if (values.studentLaptopVal == 1) { studentLaptop = "No" };
  console.log("EmailJS - Student Laptop: ", studentLaptop);

  const parentPhone = values.parentPhoneVal;
  console.log("EmailJS - Parent Phone: ", parentPhone);

  /*** Parent Attendance ***/

  console.log("values.parentAttending :", values.parentAttending);
  console.log("values.parent1Dates :", values.parent1Dates);
  console.log("values.parent2Dates :", values.parent2Dates);

  /* Parent 1 */

  let parent1Session1 = null;
  let parent1Session2 = null;
  let parent1Session3 = null;
  let parent1Session4 = null;

  var parent1SessionDates = null;

  if (values.parentAttending == 1 && values.parent1Dates != '') { 

    parent1SessionDates = values.parent1Dates;

    console.log("EmailJS - Parent 1 Dates: ", parent1SessionDates);

    const parent1DatesArray = values.parent1Dates.split(',').map(date => date.trim());

    const parent1HasOct17 = parent1DatesArray.includes('Oct 17');
    const parent1HasOct24 = parent1DatesArray.includes('Oct 24');
    const parent1HasNov07 = parent1DatesArray.includes('Nov 7');
    const parent1HasNov14 = parent1DatesArray.includes('Nov 14');

    if (parent1HasOct17) {
      parent1Session1 = "Oct 17th | Bull St Library";
    }

    if (parent1HasOct24) {
      parent1Session2 = "Oct 24th | Bull St Library";
    }

    if (parent1HasNov07) {
      parent1Session3 = "Nov 7th | SW Chatham Library";
    }

    if (parent1HasNov14) {
      parent1Session4 = "Nov 14th | SW Chatham Library";
    }
  };

  var parent1Laptop = null;
  if (values.parent1Laptop == 0) { parent1Laptop = "Yes" };
  if (values.parent1Laptop == 1) { parent1Laptop = "No" };
  console.log("EmailJS - Parent 1 Laptop: ", parent1Laptop);

  /* Parent 2 */

  let parent2Session1 = null;
  let parent2Session2 = null;
  let parent2Session3 = null;
  let parent2Session4 = null;

  var parent2SessionDates = null;

  if (values.parentAttending == 1 && values.parent2Dates != '') { 

    parent2SessionDates = values.parent2Dates 
  
    console.log("EmailJS - Parent 2 Dates: ", parent2SessionDates);

    const parent2DatesArray = values.parent2Dates.split(',').map(date => date.trim());

    const parent2HasOct17 = parent2DatesArray.includes('Oct 17');
    const parent2HasOct24 = parent2DatesArray.includes('Oct 24');
    const parent2HasNov07 = parent2DatesArray.includes('Nov 7');
    const parent2HasNov14 = parent2DatesArray.includes('Nov 14');

    if (parent2HasOct17) {
      parent2Session1 = "Oct 17th | Bull St Library";
    }

    if (parent2HasOct24) {
      parent2Session2 = "Oct 24th | Bull St Library";
    }

    if (parent2HasNov07) {
      parent2Session3 = "Nov 7th | SW Chatham Library";
    }

    if (parent2HasNov14) {
      parent2Session4 = "Nov 14th | SW Chatham Library";
    }
  };

  var parent2Laptop = null;
  if (values.parent2Laptop == 0) { parent2Laptop = "Yes" };
  if (values.parent2Laptop == 1) { parent2Laptop = "No" };
  console.log("EmailJS - Parent 2 Laptop: ", parent2Laptop);

  const gcsemail = "support@girlscodesavannah.org";
  
  const templateParams = {
    parentFName: values.parentFNameVal,
    studentFName: values.studentFNameVal,
    studentName: `${values.studentFNameVal} ${values.studentLNameVal}`,
    studentType: studentType,
    session1: session1,
    session2: session2,
    session3: session3,
    session4: session4,
    studentLaptop: studentLaptop,
    parentAttending: values.parentAttending,
    parent1Name: `${values.parentFNameVal} ${values.parentLNameVal}`,
    parent1Dates: parent1SessionDates,
    parent1Session1: parent1Session1,
    parent1Session2: parent1Session2,
    parent1Session3: parent1Session3,
    parent1Session4: parent1Session4,
    parent1Laptop: parent1Laptop,
    parent2Name: `${values.parent2FName} ${values.parent2LName}`,
    parent2Dates: parent2SessionDates,
    parent2Session1: parent2Session1,
    parent2Session2: parent2Session2,
    parent2Session3: parent2Session3,
    parent2Session4: parent2Session4,
    parent2Laptop: parent2Laptop,
    parentName: `${values.parentFNameVal} ${values.parentLNameVal}`,
    parentPhone: parentPhone,
    email: values.parentEmailVal,
    gcsemail: gcsemail
  };

  console.log("EmailJS templateParams: ", templateParams);

  if (values.parentEmailVal) {

    emailjs
      .send("service_dxz4hwm", "template_53yvjex", templateParams)
      .then(() => {
        console.log("Message sent successfully.");
      })
      .catch((error) => {
        console.log("Error sending email: ", error);
      });
  }
}